import React, { Component } from "react";
import { api } from "api";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import Select from "react-select";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import YearRangePicker from "components/elements/year-range-picker";
import ExamResultDetail from "./ExamResultDetail";
import i18n from "i18next";

/*
      MechanicalS = 10049;
      Body / PaintS = 10050
      SalesS = 10047
      Service Administration = 10048
    */

class ExamResults extends Component {
  state = {
    employees: [],
    selectedDepartment: null,
    selectedEmployee: null,
    selectedStartYear: new Date().getFullYear() - 1,
    selectedEndYear: new Date().getFullYear(),
    employeeOptions: [],
    isManager: localStorage.getItem("roles").includes("Manager"),
    examResults: [],
  };

  deparmentOptions = [
    { value: "50020", label: i18n.t("10049") },
    { value: "50021", label: i18n.t("10050") },
    { value: "50022", label: i18n.t("10047") },
    { value: "50023", label: i18n.t("10048") },
  ];

  componentDidMount() {
    if (localStorage.getItem("roles").includes("Manager")) this.getEmployees();

    if (!localStorage.getItem("roles").includes("Manager"))
      this.getExamResults(
        this.state.selectedStartYear,
        this.state.selectedEndYear
      );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.employees !== this.state.employees) {
      const currentEmployee = this.state.employees.find(
        (z) => z.id === this.props.profile.general.id
      );

      if (!currentEmployee) return;

      const currentEmployeeDepartment = this.deparmentOptions.find(
        (o) => o.value === String(currentEmployee.serviceType.value)
      );

      const employeesOfDepartment = this.state.employees.filter(
        (z) => z.serviceType.value === currentEmployee.serviceType.value
      );
      const _employeeOptions = employeesOfDepartment.map((e) => ({
        value: e.id,
        label: e.fullname,
      }));

      this.setState({
        selectedDepartment: currentEmployeeDepartment.value,
        selectedEmployee: currentEmployee.id,
        employeeOptions: _employeeOptions,
      });

      this.getExamResults(
        this.state.selectedStartYear,
        this.state.selectedEndYear,
        currentEmployee.id
      );
    }

    if (prevState.selectedDepartment !== this.state.selectedDepartment) {
      const employeesOfDepartment = this.state.employees.filter(
        (z) => z.serviceType.value === parseInt(this.state.selectedDepartment)
      );
      const _employeeOptions = employeesOfDepartment.map((e) => ({
        value: e.id,
        label: e.fullname,
      }));
      this.setState({
        employeeOptions: _employeeOptions,
      });
    }

    if (
      prevState.selectedStartYear !== this.state.selectedStartYear ||
      prevState.selectedEndYear !== this.state.selectedEndYear ||
      (prevState.selectedEmployee !== this.state.selectedEmployee &&
        prevState.selectedEmployee !== null)
    ) {
      this.getExamResults(
        this.state.selectedStartYear,
        this.state.selectedEndYear,
        this.state.selectedEmployee
      );
    }
  }

  getEmployees = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-360/employees`)
      .then((response) => {
        this.setState({
          employees: response.data.data.employees,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  getExamResults = (startYear, endYear, employeeId) => {
    this.props.onProcessBegin();
    const startDate = new Date(startYear, 0, 1, 0, 0, 0).toISOString();
    const endDate = new Date(endYear, 11, 0, 23, 59, 59).toISOString();
    let query = "";
    if (this.state.isManager)
      query = `/api/employee-360/exam-results/${startDate}/${endDate}/${employeeId}`;
    else query = `/api/employee-360/exam-results/${startDate}/${endDate}`;
    api
      .get(query)
      .then((response) => {
        this.setState({
          examResults: response.data.data.results,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  handleDepartmentSelect = (e) => {
    this.setState({ selectedDepartment: e.value, selectedEmployee: null });
  };

  renderDepartmentCombo = () => {
    const isDisabled = !this.state.isManager;

    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={isDisabled}
        options={this.deparmentOptions}
        onChange={(e) => this.handleDepartmentSelect(e)}
        // defaultValue={options[0]}
        value={this.deparmentOptions.find(
          (o) => o.value === String(this.state.selectedDepartment)
        )}
      />
    );
  };

  handleEmployeeSelect = (e) => {
    this.setState({ selectedEmployee: e.value });
  };

  renderEmployeesCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        label="ee"
        options={this.state.employeeOptions}
        onChange={(e) => this.handleEmployeeSelect(e)}
        value={
          this.state.selectedEmployee
            ? this.state.employeeOptions.find(
                (o) => o.value === this.state.selectedEmployee
              )
            : null
        }
      />
    );
  };

  renderPosition = () => {
    if (
      this.state.selectedEmployee === null ||
      this.state.selectedEmployee === ""
    )
      return null;
    const employee = this.state.employees.find(
      (z) => z.id === this.state.selectedEmployee
    );
    return <span>{employee.position.name}</span>;
  };

  handleSelectYear = (startYear, endYear) => {
    this.setState({
      selectedStartYear: startYear,
      selectedEndYear: endYear,
    });
  };

  renderYearPicker = () => {
    return (
      <YearRangePicker
        startText={i18n.t("employee360_start")}
        endText={i18n.t("employee360_end")}
        startYear={this.state.selectedStartYear}
        endYear={this.state.selectedEndYear}
        maxYear={new Date().getFullYear() + 3}
        minYear={new Date().getFullYear() - 1}
        onSelect={this.handleSelectYear}
        style={{ borderRadius: "5px", maxWidth: "300px", width: "100%" }}
      />
    );
  };

  renderFilterBar = () => {
    return (
      <>
        {this.props.spinner}
        {this.state.isManager ? (
          <div className="d-flex flex-column flex-lg-row justify-content-end align-items-center mb-4">
            <div
              className="d-flex align-items-center flex-grow-1 w-100"
              style={{ gap: "10px" }}
            >
              <label>
                <Trans>employee360_department</Trans>
              </label>
              <div style={{ width: "100%", maxWidth: "300px" }}>
                {this.renderDepartmentCombo()}
              </div>
            </div>
            <div
              className="d-flex align-items-center flex-grow-1 w-100"
              style={{ gap: "10px" }}
            >
              <label>
                <Trans>employee360_personnel</Trans>
              </label>
              <div style={{ width: "100%", maxWidth: "300px" }}>
                {this.renderEmployeesCombo()}
              </div>
            </div>
            <div
              className="d-flex align-items-center flex-grow-1 w-100"
              style={{ gap: "10px" }}
            >
              <label>
                <Trans>employee360_position</Trans>
              </label>
              {this.renderPosition()}
            </div>
            <div
              className="d-flex align-items-center flex-grow-1 w-100"
              style={{ gap: "10px" }}
            >
              <label>
                <Trans>employee360_dateofexam</Trans>
              </label>
              {this.renderYearPicker()}
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column flex-lg-row justify-content-end align-items-center mb-4">
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <label>
                <Trans>employee360_dateofexam</Trans>
              </label>
              {this.renderYearPicker()}
            </div>
          </div>
        )}

        <hr />
      </>
    );
  };

  renderExamResults = () => {
    if (this.state.examResults.length === 0) return null;

    return (
      <div className="mt-4">
        <div className="d-flex justify-content-left mb-4">
          <b>
            <Trans>employee360_successstatus</Trans>
          </b>
          <div
            style={{
              background: "#4cc790",
              borderRadius: "20px",
              textAlign: "center",
              padding: "0px 16px",
              color: "#fff",
              marginLeft: "10px",
            }}
          >
            <Trans>employee360_successful</Trans>
          </div>
          <div
            style={{
              background: "#e42c3b",
              borderRadius: "20px",
              textAlign: "center",
              padding: "0px 16px",
              color: "#fff",
              marginLeft: "10px",
            }}
          >
            <Trans>employee360_notyet</Trans>
          </div>
        </div>

        {this.state.examResults.map((exam, index) => (
          <ExamResultDetail
            key={exam.examType.value}
            exam={exam}
            defaultActive={index === 0 ? exam.examType.value : null}
          />
        ))}
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.renderFilterBar()}
        {this.renderExamResults()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    profile: state.profile,
  };
};

export default connect(
  mapStateToProps,
  {}
)(requireAuth(containsLongRunningProcess(ExamResults)));
